module.exports = __webpack_public_path__ + "media/images/amenities_icons/standing_desk-fc21d2a0f1f97d6a01b2564e7f2e7244.svg";